<template>
  <div>
    <div class="is-size-3 mb-5 ml-5">
      City Photo Admin Tool
    </div>

    <b-tabs v-model="activeTab">
      <b-tab-item label="Google Photos">
        <div v-if="googlePhotos">
          <div v-for="(photo, index) in googlePhotos" :key="index" class="box">
            <img
              :src="getUrl(photo)"
              style="max-width:600px;max-height:300px"
            />

            <div class="mb-2">{{ photo.photo_reference }}</div>
            <b-button type="is-primary" @click="savePhoto(photo)"
              >Save</b-button
            >
          </div>
        </div>
        <div v-else>
          Loading...
        </div>
      </b-tab-item>

      <b-tab-item label="Selected Photos">
        <div v-if="savedPhotos">
          <div v-for="(photo, index) in savedPhotos" :key="index" class="box">
            <img
              :src="getUrl(photo)"
              style="max-width:600px;max-height:300px"
            />
            <div class="mb-2">{{ photo.photo_reference }}</div>
            <b-button type="is-primary" @click="deletePhoto(photo)"
              >Remove</b-button
            >
          </div>
        </div>
        <div v-else>
          Loading...
        </div>
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
export default {
  name: "CityPhotos",
  props: {
    code: {
      required: true,
      //type: Object,
    },
  },
  data() {
    return {
      activeTab: 0,
      googlePhotos: null,
      savedPhotos: null,
    };
  },
  methods: {
    async getGooglePhotos() {
      let result = await this.$app.huddleLabsServerCall(
        "resources/city-photos/google-list",
        {
          code: this.code,
        }
      );

      this.googlePhotos = result;
    },
    async getSavedPhotos() {
      let result = await this.$app.huddleLabsServerCall(
        "resources/city-photos/list",
        {
          code: this.code,
        }
      );

      this.savedPhotos = result;
    },
    async savePhoto(photo) {
      let ref = photo.photo_reference;
      let result = await this.$app.huddleLabsServerCall(
        "resources/city-photos/save",
        {
          photo_reference: ref,
          code: this.code,
        }
      );
    },
    async deletePhoto(photo) {
      let id = photo._id;
      let result = await this.$app.huddleLabsServerCall(
        "resources/city-photos/delete",
        {
          id: id,
        }
      );
    },
    getUrl(photo) {
      return (
        "https://maps.googleapis.com/maps/api/place/photo?maxwidth=800&photo_reference=" +
        photo.photo_reference +
        "&key=" +
        this.$appConfig.googleKey
      );
    },
  },
  async mounted() {
    await this.getGooglePhotos();
    await this.getSavedPhotos();
  },
};
</script>

<style scoped>
.trip-container {
  position: relative;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  padding-bottom: 50%;
  cursor: pointer;
  background-color: #8f9295;
  max-width: 600px;
  max-height: 300px;
  margin: 0 auto;
}
</style>
